export default "__VITE_ASSET__CWQekuCP__"